import { Module, VuexModule, Mutation } from 'vuex-module-decorators';
import type { CancellationTokens, CancelRequest } from '@/ts/interfaces/Loading';
import { CANCEL_REQUEST_BY } from '@/ts/interfaces/Loading';

@Module({name: 'Loading', namespaced: true})
export default class Loading extends VuexModule {
    public loadingStatus: boolean = false;
    public loadingLock: boolean = false;
    public requestsCancellationTokens: CancellationTokens[] = [];

    @Mutation
    public RESET_LOADING_STORE_STATE() {
        this.loadingStatus              = false;
        this.loadingLock                = false;
        this.requestsCancellationTokens = [];
    }

    get getLoadingStatus(): boolean {
        return this.loadingStatus;
    }

    get getLoadingLockStatus(): boolean {
        return this.loadingLock;
    }

    get getRequestTokenByURL()  {
        return ((url: string) => {
            return this.requestsCancellationTokens.find((t) => t.url === url);
        });
    }

    @Mutation
    public SET_LOADING_STATUS(loadingStatus: boolean) {
        this.loadingStatus = loadingStatus;
    }

    @Mutation
    public SET_LOADING_LOCK_STATUS(loadingLockStatus: boolean) {
        this.loadingLock = loadingLockStatus;
    }

    @Mutation
    public TOGGLE_CANCELLATION_TOKEN(token: CancellationTokens) {
        token.url   = token.url.includes('?') ? token.url.substring(0, token.url.indexOf('?')) : token.url;
        const index = this.requestsCancellationTokens.findIndex((t) => t.url === token.url);

        if (index !== -1) {
            this.requestsCancellationTokens.splice(index, 1);
            return;
        }

        if (token.cancelToken) {
            this.requestsCancellationTokens.push(token);
        }
    }

    @Mutation
    public CANCEL_REQUEST(config: CancelRequest) {
        if (config.by === CANCEL_REQUEST_BY.BY_URL) {
            const index = this.requestsCancellationTokens.findIndex((t) => t.url === config.url);

            if (index !== -1) {
                this.requestsCancellationTokens[index].source.cancel(config.url);
                this.requestsCancellationTokens.splice(index, 1);
            }
        }

        if (config.by === CANCEL_REQUEST_BY.BY_LAST) {
            const index = this.requestsCancellationTokens.length - 1;

            if (index > -1) {
                this.requestsCancellationTokens[index].source.cancel(config.url);
                this.requestsCancellationTokens.splice(index, 1);
            }
        }

        if (config.by === CANCEL_REQUEST_BY.ALL) {
            let tokensLength = 0;

            while (this.requestsCancellationTokens.length) {
                if (this.requestsCancellationTokens[tokensLength]) {
                    this.requestsCancellationTokens[tokensLength].source.cancel(config.url);
                }

                this.requestsCancellationTokens.shift();
                tokensLength++;

                // Just for safe of infinite loop
                if (tokensLength > 100) {
                    break;
                }
            }
        }
    }
}
